import { EmailSettings } from '../../types/EmailSettings';
import { libApiInstance } from '../axios';

export async function requestUserEmailSettings(signal?: AbortSignal): Promise<EmailSettings> {
    const result = await libApiInstance.get(`/config/parameters/email`, {
        signal,
    });
    return result.data;
}

export async function requestAssignEmailSettings(
    settings: EmailSettings,
    signal?: AbortSignal,
): Promise<unknown> {
    const result = await libApiInstance.put('/config/parameters/email', settings, {
        signal,
    });
    return result;
}

export async function requestTestEmailSettings(
    settings: EmailSettings,
    signal?: AbortSignal,
): Promise<unknown> {
    const result = await libApiInstance.post('/config/parameters/email/test', settings, {
        signal,
    });
    return result;
}

export async function requestDisconnectEmailSettings(signal?: AbortSignal) {
    const result = await libApiInstance.delete(`/config/parameters/email`, {
        signal,
    });
    return result;
}
